<template>
<v-card flat tile>
  <v-container class="secondary lighten-1 white--text pb-6">
    <v-card-text class="text-center">
      {{$store.state.app.login_description}}
    </v-card-text>
    <v-row justify="center">
      <v-btn tile class="mr-2" @click="loadFacebook">
        <v-icon class="mr-2" :color="$helpers.linkColor('facebook')">fab fa-facebook</v-icon>
        Facebook
      </v-btn>
      <v-btn tile class="ml-2" @click="loadGoogle">
        <v-img style="height:24px;width:23px" class="mr-2" src="/google.png" /> Google
      </v-btn>
    </v-row>
  </v-container>
  <v-container>
    <h4 class="text-center mb-4 mt-2 grey--text text--darken-3">Sign in</h4>
    <v-form ref="login-form" lazy-validation onSubmit="return false;">
      <v-row justify="center">
        <v-col cols="10" md="10" class="py-0">
          <v-text-field outlined label="Email" v-model="login.email" :rules="[rules.email]" clearable tabindex="1"></v-text-field>
        </v-col>
        <v-col cols="10" md="10" class="py-0">
          <v-text-field outlined type="password" v-on:keyup.enter="submitLogin" v-model="login.password" :rules="[rules.required]" label="Password" clearable tabindex="2"></v-text-field>
        </v-col>
        <v-col cols="12" md="10" class="py-0 text-center" v-if="error">
          <v-alert type="error">
            {{error}}
          </v-alert>
        </v-col>
      </v-row>
    </v-form>
  </v-container>


  <v-card-actions class="grey lighten-3">
    <v-btn icon to="/">
      <v-icon>fa-home</v-icon>
    </v-btn>
    <v-btn text small @click="$emit('tab','forgot')">Forgot password</v-btn>
    <v-spacer></v-spacer>
    <v-btn class="primary" @click="submitLogin" :loading="loading" tabindex="3">Sign In</v-btn>
  </v-card-actions>

</v-card>
</template>
<script>
export default {
  name: "",
  data: () => ({
    login: {
      email: '',
      password: ''
    },
    facebook_response: {},
    error: null,
    loading: false
  }),
  computed: {
    rules() {
      return { ...this.$helpers.rules
      }
    }
  },
  created() {

  },
  methods: {
    loadGoogle() {
      let self = this;
      this.$google.signIn(function(googleUser) {
        let token = googleUser.getAuthResponse().id_token;
        self.googleLogin(token)
      }, function(error) {
        this.error = error
      })
    },
    async googleLogin(token) {
      try {
        this.loading = true
        await this.$store.dispatch('account/google_login', token)
      } catch (ex) {
        this.error = ex.error
      }
      this.loading = false
    },
    checkFacebook() {
      let self = this;
      window.FB.getLoginStatus(function(res) {
        if (res.status === "connected") {
          self.facebookLogin(res)
        }
      })
    },
    loadFacebook() {
      let self = this;
      window.FB.login((res) => {
        if (res.status === "connected") {
          self.facebookLogin(res.authResponse.accessToken)
        }
      }, {
        scope: 'public_profile,email'
      })
    },
    async facebookLogin(token) {
      try {
        this.loading = true
        await this.$store.dispatch('account/facebook_login', token)
      } catch (ex) {
        this.error = ex.error
      }
      this.loading = false
    },
    async submitLogin() {
      if (!this.$refs['login-form'].validate()) {
        return
      }
      this.loading = true;
      try {
        await this.$store.dispatch('account/login', {
          email: this.login.email,
          password: this.login.password
        })
      } catch (ex) {
        console.log("ex", ex)
        this.login.password = ''
        this.error = ex.error
      }
      this.loading = false;
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
